<template lang='pug'>
.container-fluid.p-0.push-wrapper
	.container
		.row
			.col
				.row
					.col-12.my-header.font-weight-bold
						| Неактивные карты

	.container.mt-5
		.white_block
			.row
				.col
					h5 Гости, которым нужна карта
					| Мы опредилили, что эти гости, скорее всего, часто ходят в Ваше зведение, но почему-то их карта не обновляется.
					br
					| Вероятно, они сменили мобильное устройство или выключили автообновление карты.
			.row(v-if="!loading")
				.col.mt-3(v-if="importantCards.length == 0")
					i.far.fa-check(style="margin-right: 5px")
					| Поздравляем, таких карт нет!
				.col(v-else)
					vue-good-table(
						:columns="columns",
						:rows="importantCards",
						:search-options="{ enabled: true, skipDiacritics: true, placeholder: 'Поиск по картам' }",
						:pagination-options="{ enabled: true, perPage: 50, nextLabel: 'Дальше', prevLabel: 'Назад', ofLabel: 'из', pageLabel: 'страница', allLabel: 'Всё', rowsPerPageLabel: 'Строк на странице' }",
						styleClass="datatable vgt-table condensed"
					)
			.row(v-if="loading")
				.col-sm
					.loader_holder(style="margin: 0 auto; width: 200px")
						object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
	.container.mt-5
		.white_block
			.row
				.col
					h5 Гости, которые вообще перестали пользоваться картой и не получают обновления
					| Мы опредилили, что этим гостям мы постоянно отправляем пуши, но их устройства не отвечают.
					br
					| За все время им было отправлено мало пушей, что говорит о том, что, скорее всего, картой они не пользовались.
			.row(v-if="!loading")
				.col.mt-3(v-if="notImportantCards.length == 0")
					i.far.fa-check(style="margin-right: 5px")
					| Поздравляем, таких карт нет!
				.col(v-else)
					vue-good-table(
						:columns="columns",
						:rows="notImportantCards",
						:search-options="{ enabled: true, skipDiacritics: true, placeholder: 'Поиск по картам' }",
						:pagination-options="{ enabled: true, perPage: 50, nextLabel: 'Дальше', prevLabel: 'Назад', ofLabel: 'из', pageLabel: 'страница', allLabel: 'Всё', rowsPerPageLabel: 'Строк на странице' }",
						styleClass="datatable vgt-table condensed"
					)
			.row(v-if="loading")
				.col-sm
					.loader_holder(style="margin: 0 auto; width: 200px")
						object(type="image/svg+xml", data="/assets/loaders/infinity.svg")

	.container.mt-5
		.white_block
			.row
				.col
					h5 Принцип работы
					ul
						li Мы определяем список карт, которым мы отправляем пуши, но они не доходят до устройства.
						li Так же мы определяем средневзвешенное значение количества пушей за месяц.
						li Если гостю было отправлено больше чем среднее значение, то мы предполагаем, что кроме промо-пушей он получает уведомления о новом уровне или об бонусном пополнении/снятии.
						li Если гостю было отправлено меньше среднего значения, то мы предполагаем что гость должен был получать только промо-акции, но картой не пользовался.

					h5 Пример
					ul
						li За последний месяц вы отправили 2 промо-пуша.
						li Есть 3 карты:
							br
							| Карта #111, ей было отправлено 11 пушей. Но смартфон гостя ничего не получил.
							br
							| Карта #222, ей было отправлено 2 пуша. Смартфон гостя так же ничего не получил.
							br
							| Карта #333, ей было отправлено 2 пуша. Смартфон гостя так же ничего не получил.
						li Можно сделать вывод, что карта #111 часто используется в заведении, а #222 и #333 должны были только получить промо-пуши.
						li Средневзвешенным является 2.
						li Соответственно, #111 попадает в список "Гости, которым нужна карта"
						li А #222 и #333 попадают в список "Гости, которые вообще перестали пользоваться картой и не получают обновления"
			.row(v-if="!loading")
				.col
					a(
						:href="`https://faq.wallet.actid.ru/?sp=${shopPath}&q=cardNotUpdated`",
						target="_blank"
					) Узнайте: Почему гость не может получить обновление карты?
</template>

<script>
	import { Tooltip } from "element-ui";
	import apiDriver from "../../apiDriver";
	import moment from "moment";

	export default {
		components: {
			[Tooltip.name]: Tooltip,
		},

		data() {
			return {
				loading: true,
				shopPath: "",
				importantCards: [],
				notImportantCards: [],
				columns: [
					{
						label: "CID",
						field: "card_id",
					},
					{
						label: "Карта",
						field: "last_data",
						sortable: false,
						formatFn: this.cardFormatFn,
					},
					{
						label: "Пушей",
						field: "pushes",
					},
					{
						label: "Имя",
						field: "last_data.firstname",
					},
					{
						label: "Фамилия",
						field: "last_data.lastname",
					},
					{
						label: "Телефон",
						field: "last_data.phone",
					},
					{
						label: "Email",
						field: "last_data.email",
					},
				],
			};
		},

		computed: {},

		async mounted() {
			this.loading = true;
			await this.getDeadCards();
			await this.loadFormLink();
			this.loading = false;
		},

		methods: {
			cardFormatFn(value) {
				return value.card_number || value.client_id;
			},
			async getDeadCards() {
				let from = moment().add(-14, "days"),
					to = moment().add(1, "day");
				let dead_cards = await apiDriver.services.api.get(
					"cards",
					"stats/dead_cards",
					{ from, to }
				);

				console.log(dead_cards.data.list);

				let numbers_amount = {};
				let numbers = dead_cards.data.list.map((x) => x.pushes);
				for (let n of numbers) {
					if (!numbers_amount[n]) numbers_amount[n] = { amount: 0, weight: 0 };
					numbers_amount[n].amount++;
				}
				for (let n of Object.keys(numbers_amount)) {
					numbers_amount[n].weight = numbers_amount[n].amount / numbers.length;
				}
				let more_then_half = [];
				let multiplicator = 0;
				let half_counter = 0;
				for (let n of Object.keys(numbers_amount)) {
					multiplicator += n * numbers_amount[n].weight;
					if (half_counter >= 0.5) continue;
					half_counter += numbers_amount[n].weight;
					more_then_half.push(n);
				}
				let result =
					more_then_half.reduce((x, y, z) => Number(x) + Number(y), 0) /
					more_then_half.length;

				let ceiled_multiplicator = Math.ceil(multiplicator);

				this.importantCards = dead_cards.data.list.filter(
					(x) => x.pushes >= ceiled_multiplicator
				);

				this.notImportantCards = dead_cards.data.list.filter(
					(x) => x.pushes < ceiled_multiplicator
				);

				// console.log(numbers_amount);
				// console.log(more_then_half);
				// console.log(multiplicator, ceiled_multiplicator);
				// console.log(result);
			},
			async loadFormLink() {
				let formlink_req = await apiDriver.services.api.get(
					"cards",
					"wallet/formlink"
				);
				this.shopPath = formlink_req.data.route;
			},
		},
	};
</script>
<style scoped lang="stylus">
	div {
		cursor: default;
	}

	a {
		margin-bottom: 2px;
		background: #3f51b5;
		color: white;
		padding: 5px 10px;
		border-radius: 5px;
		display: inline-block;

		&:hover {
			color: white;
		}

		&:focus {
			color: white;
		}
	}

	.my-header {
		font-size: 26pt;
	}

	.header-pre-push {
		font-size: 1.5rem;
	}

	.header-push {
		font-size: 1.5rem;
		color: black;
	}

	button.styled {
		margin-bottom: 5px;
		border: 1px solid #6c68cb;
		padding: 10px 15px;
		border-radius: 4px;
		color: #464384;
		cursor: pointer;
		background: white;

		&:hover {
			background: #6c68cb;
			color: white;
		}

		&[disabled] {
			border-color: #ddd;
			color: #ddd;
			cursor: default;
			background: white;
		}

		&:last-child {
			margin-bottom: 0;
		}
	}

	.design {
		background: white;
	}

	.inputModule {
		margin-bottom: 10px;

		&.extended {
			border-left: 4px solid #f4f3ef;
			padding-left: 15px;
			margin-left: 10px;
			padding-top: 10px;
		}
	}
</style>
